import {
  CuratedReviewsQueryParams,
  MyReviewsQueryParams,
  ProductReviewsQueryParams,
  ProductStatistic,
  Review,
  ReviewCreditAmounts,
  ReviewCreditAmountsQueryParams,
  ReviewCreditEligibility,
  ReviewCreditSummary,
  ReviewCreditSummaryQueryParams,
  ReviewStatisticsQueryParams,
} from '../../../model';

export type GetProductReviewsRequest = ProductReviewsQueryParams;

export type GetProductReviewsResponse = Review[];

export type GetAIProductReviewsRequest = GetProductReviewsRequest;
export type GetAIProductReviewsResponse = Review[];

export type GetCuratedReviewsRequest = CuratedReviewsQueryParams;

export type GetCuratedReviewsResponse = Review[];

export type GetMyReviewsRequest = MyReviewsQueryParams;

export type GetMyReviewsResponse = Review[];

export type GetReviewCreditAmountsRequest = ReviewCreditAmountsQueryParams;

export type GetReviewCreditAmountsResponse = ReviewCreditAmounts;

/** Per reader, so a guest gets a 401 rather than a blank verdict — callers gate on the session instead. */
export type GetReviewCreditEligibilityRequest = {
  productId: number;
};

export type GetReviewCreditEligibilityResponse = ReviewCreditEligibility;

export type GetReviewCreditSummaryRequest = ReviewCreditSummaryQueryParams;

export type GetReviewCreditSummaryResponse = ReviewCreditSummary;

export type ReviewStatisticsRequest = ReviewStatisticsQueryParams;

export type ReviewStatisticsResponse = {
  statistics: ProductStatistic[];
};

/** The endpoint signs the content type, so the PUT must send exactly what was declared here. */
export type CreateReviewMediaPresignedUrlRequest = {
  contentType: string;
  sizeBytes: number;
};

export type CreateReviewMediaPresignedUrlResponse = {
  uploadUrl: string;
  mediaUrl: string;
};

export type CreateReviewRequest = {
  reviewId?: number;
  name: string;
  email?: string;
  rating: number;
  body: string;
  productId: number;
  title?: string;
  /** Never reaches the API: the client uploads each file first and resolves this into `mediaUrls`. */
  files?: File[];
  /** Already in storage, in display order. `files` are appended after these, matching the form. */
  mediaUrls?: string[];
  skinType: string[];
  skinConcern: string[];
  /** Optional on the wire, but validated whenever sent: an unrecognised token is a 400. */
  recommend?: string;
  ageGroup?: string;
  gender?: string;
  /** Points the credit check at one order instead of searching the customer's completed orders. */
  orderId?: string;
};

export type CreateReviewResponse = Review;

/**
 * Only rating, text and media are editable. Sending neither retention list keeps every attachment;
 * sending one empty removes everything it governs. The two are mutually exclusive.
 */
export type UpdateReviewRequest = {
  reviewId: number;
  productId: number;
  rating?: number;
  title?: string;
  body?: string;
  skinType?: string[];
  skinConcern?: string[];
  /** Pictures alone — a video survives whatever this leaves out, so an older client cannot drop one. */
  keepPictureUrls?: string[];
  /** Governs every attachment whatever its type, and is the only way to drop a video. */
  keepMediaUrls?: string[];
  /** Uploaded to storage first, then appended to whatever is kept. */
  files?: File[];
  mediaUrls?: string[];
};

export type UpdateReviewResponse = Review;
